var exports = {
  "Xq": "x43aef4ae--5bd43b--card-image",
  "SC": "x43aef4ae--5bd43b--rectangle-container",
  "YC": "x43aef4ae--5bd43b--rectangle",
  "kE": "x43aef4ae--5bd43b--rectangle-text",
};

module.exports = exports;
